
import { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';

export default function CountriesPage() {
  const [searchTerm, setSearchTerm] = useState('');

  const countries = [
    {
      name: 'İspanya',
      slug: 'ispanya',
      flag: '🇪🇸',
      type: 'Schengen',
      description: 'İspanya Schengen vizesi için profesyonel danışmanlık hizmeti',
      image: 'https://public.readdy.ai/ai/img_res/34d277afba7a9e5563da7935e5d10347.jpg'
    },
    {
      name: 'Fransa',
      slug: 'fransa',
      flag: '🇫🇷',
      type: 'Schengen',
      description: 'Fransa Schengen vizesi başvuru sürecinizi yönetiyoruz',
      image: 'https://readdy.ai/api/search-image?query=eiffel%20tower%20paris%20france%20iconic%20landmark%20golden%20sunset%20romantic%20city%20beautiful%20architecture%20seine%20river%20view%20tourist%20destination&width=600&height=400&seq=france-tourist-002&orientation=landscape'
    },
    {
      name: 'Almanya',
      slug: 'almanya',
      flag: '🇩🇪',
      type: 'Schengen',
      description: 'Almanya vizesi için eksiksiz evrak hazırlığı',
      image: 'https://readdy.ai/api/search-image?query=brandenburg%20gate%20berlin%20germany%20historic%20landmark%20blue%20sky%20iconic%20neoclassical%20architecture%20tourist%20destination%20famous%20monument&width=600&height=400&seq=germany-tourist-003&orientation=landscape'
    },
    {
      name: 'İngiltere',
      slug: 'ingiltere',
      flag: '🇬🇧',
      type: 'Ulusal Vize',
      description: 'İngiltere vizesi başvurularında uzman desteği',
      image: 'https://readdy.ai/api/search-image?query=big%20ben%20tower%20bridge%20london%20england%20iconic%20clock%20tower%20thames%20river%20historic%20landmark%20tourist%20destination%20beautiful%20architecture&width=600&height=400&seq=uk-tourist-004&orientation=landscape'
    },
    {
      name: 'Yunanistan',
      slug: 'yunanistan',
      flag: '🇬🇷',
      type: 'Schengen',
      description: 'Yunanistan Schengen vizesi için Kosmos Vize desteği',
      image: 'https://readdy.ai/api/search-image?query=santorini%20greece%20white%20buildings%20blue%20domes%20aegean%20sea%20beautiful%20island%20scenic%20view%20sunset%20caldera%20romantic%20destination&width=600&height=400&seq=greece-tourist-005&orientation=landscape'
    },
    {
      name: 'Hollanda',
      slug: 'hollanda',
      flag: '🇳🇱',
      type: 'Schengen',
      description: 'Hollanda vizesi başvuru sürecinizi kolaylaştırıyoruz',
      image: 'https://readdy.ai/api/search-image?query=amsterdam%20canal%20houses%20netherlands%20colorful%20buildings%20water%20reflections%20dutch%20architecture%20historic%20windmills%20tulips%20tourist%20destination&width=600&height=400&seq=netherlands-tourist-006&orientation=landscape'
    },
    {
      name: 'İtalya',
      slug: 'italya',
      flag: '🇮🇹',
      type: 'Schengen',
      description: 'İtalya Schengen vizesi için profesyonel hizmet',
      image: 'https://readdy.ai/api/search-image?query=colosseum%20rome%20italy%20ancient%20amphitheater%20historic%20landmark%20blue%20sky%20iconic%20architecture%20tourist%20destination%20roman%20empire&width=600&height=400&seq=italy-tourist-007&orientation=landscape'
    },
    {
      name: 'Bulgaristan',
      slug: 'bulgaristan',
      flag: '🇧🇬',
      type: 'Ulusal Vize',
      description: 'Bulgaristan vizesi başvurularında güvenilir destek',
      image: 'https://readdy.ai/api/search-image?query=rila%20monastery%20bulgaria%20orthodox%20church%20mountains%20colorful%20frescoes%20historic%20religious%20architecture%20unesco%20world%20heritage%20site&width=600&height=400&seq=bulgaria-tourist-008&orientation=landscape'
    },
    {
      name: 'İsviçre',
      slug: 'isvicre',
      flag: '🇨🇭',
      type: 'Schengen',
      description: 'İsviçre Schengen vizesi için detaylı danışmanlık',
      image: 'https://readdy.ai/api/search-image?query=matterhorn%20switzerland%20alps%20mountain%20peak%20snow%20scenic%20landscape%20majestic%20nature%20zermatt%20ski%20resort%20beautiful%20panorama&width=600&height=400&seq=switzerland-tourist-009&orientation=landscape'
    },
    {
      name: 'Avusturya',
      slug: 'avusturya',
      flag: '🇦🇹',
      type: 'Schengen',
      description: 'Avusturya vizesi başvuru sürecinizi yönetiyoruz',
      image: 'https://readdy.ai/api/search-image?query=schonbrunn%20palace%20vienna%20austria%20baroque%20architecture%20beautiful%20gardens%20historic%20imperial%20residence%20tourist%20destination&width=600&height=400&seq=austria-tourist-010&orientation=landscape'
    },
    {
      name: 'Belçika',
      slug: 'belcika',
      flag: '🇧🇪',
      type: 'Schengen',
      description: 'Belçika Schengen vizesi için profesyonel hizmet',
      image: 'https://readdy.ai/api/search-image?query=grand%20place%20brussels%20belgium%20historic%20square%20ornate%20buildings%20golden%20architecture%20gothic%20baroque%20tourist%20destination&width=600&height=400&seq=belgium-tourist-011&orientation=landscape'
    },
    {
      name: 'Portekiz',
      slug: 'portekiz',
      flag: '🇵🇹',
      type: 'Schengen',
      description: 'Portekiz vizesi başvurularında uzman desteği',
      image: 'https://readdy.ai/api/search-image?query=belem%20tower%20lisbon%20portugal%20historic%20fortress%20tagus%20river%20manueline%20architecture%20tourist%20destination%20beautiful%20sunset&width=600&height=400&seq=portugal-tourist-012&orientation=landscape'
    },
    {
      name: 'İsveç',
      slug: 'isvec',
      flag: '🇸🇪',
      type: 'Schengen',
      description: 'İsveç Schengen vizesi için eksiksiz evrak hazırlığı',
      image: 'https://readdy.ai/api/search-image?query=stockholm%20sweden%20gamla%20stan%20colorful%20buildings%20waterfront%20scandinavian%20architecture%20old%20town%20historic%20tourist%20destination&width=600&height=400&seq=sweden-tourist-013&orientation=landscape'
    },
    {
      name: 'Norveç',
      slug: 'norvec',
      flag: '🇳🇴',
      type: 'Schengen',
      description: 'Norveç vizesi başvuru sürecinizi kolaylaştırıyoruz',
      image: 'https://readdy.ai/api/search-image?query=geirangerfjord%20norway%20fjord%20mountains%20water%20scenic%20nature%20dramatic%20landscape%20northern%20lights%20aurora%20tourist%20destination&width=600&height=400&seq=norway-tourist-014&orientation=landscape'
    },
    {
      name: 'Danimarka',
      slug: 'danimarka',
      flag: '🇩🇰',
      type: 'Schengen',
      description: 'Danimarka Schengen vizesi için profesyonel danışmanlık',
      image: 'https://readdy.ai/api/search-image?query=nyhavn%20copenhagen%20denmark%20colorful%20houses%20canal%20boats%20scandinavian%20architecture%20tourist%20destination%20beautiful%20waterfront&width=600&height=400&seq=denmark-tourist-015&orientation=landscape'
    },
    {
      name: 'Finlandiya',
      slug: 'finlandiya',
      flag: '🇫🇮',
      type: 'Schengen',
      description: 'Finlandiya vizesi başvurularında güvenilir destek',
      image: 'https://readdy.ai/api/search-image?query=helsinki%20cathedral%20finland%20white%20church%20blue%20sky%20neoclassical%20architecture%20senate%20square%20northern%20lights%20aurora%20borealis&width=600&height=400&seq=finland-tourist-016&orientation=landscape'
    },
    {
      name: 'Polonya',
      slug: 'polonya',
      flag: '🇵🇱',
      type: 'Schengen',
      description: 'Polonya Schengen vizesi için detaylı danışmanlık',
      image: 'https://readdy.ai/api/search-image?query=krakow%20poland%20main%20square%20historic%20architecture%20colorful%20buildings%20medieval%20city%20wawel%20castle%20tourist%20destination&width=600&height=400&seq=poland-tourist-017&orientation=landscape'
    },
    {
      name: 'Çekya',
      slug: 'cekya',
      flag: '🇨🇿',
      type: 'Schengen',
      description: 'Çekya vizesi başvuru sürecinizi yönetiyoruz',
      image: 'https://readdy.ai/api/search-image?query=prague%20castle%20czech%20republic%20historic%20architecture%20vltava%20river%20charles%20bridge%20panoramic%20view%20tourist%20destination&width=600&height=400&seq=czech-tourist-018&orientation=landscape'
    },
    {
      name: 'Macaristan',
      slug: 'macaristan',
      flag: '🇭🇺',
      type: 'Schengen',
      description: 'Macaristan Schengen vizesi için profesyonel hizmet',
      image: 'https://readdy.ai/api/search-image?query=budapest%20parliament%20hungary%20danube%20river%20gothic%20architecture%20illuminated%20night%20view%20chain%20bridge%20tourist%20destination&width=600&height=400&seq=hungary-tourist-019&orientation=landscape'
    },
    {
      name: 'Slovakya',
      slug: 'slovakya',
      flag: '🇸🇰',
      type: 'Schengen',
      description: 'Slovakya vizesi başvurularında uzman desteği',
      image: 'https://readdy.ai/api/search-image?query=bratislava%20castle%20slovakia%20danube%20river%20historic%20fortress%20panoramic%20city%20view%20old%20town%20tourist%20destination&width=600&height=400&seq=slovakia-tourist-020&orientation=landscape'
    },
    {
      name: 'Slovenya',
      slug: 'slovenya',
      flag: '🇸🇮',
      type: 'Schengen',
      description: 'Slovenya Schengen vizesi için eksiksiz evrak hazırlığı',
      image: 'https://readdy.ai/api/search-image?query=lake%20bled%20slovenia%20island%20church%20mountains%20alpine%20scenery%20emerald%20water%20beautiful%20nature%20tourist%20destination&width=600&height=400&seq=slovenia-tourist-021&orientation=landscape'
    },
    {
      name: 'Hırvatistan',
      slug: 'hirvatistan',
      flag: '🇭🇷',
      type: 'Schengen',
      description: 'Hırvatistan vizesi başvuru sürecinizi kolaylaştırıyoruz',
      image: 'https://readdy.ai/api/search-image?query=dubrovnik%20croatia%20old%20town%20adriatic%20sea%20medieval%20walls%20orange%20roofs%20coastal%20city%20game%20of%20thrones%20tourist%20destination&width=600&height=400&seq=croatia-tourist-022&orientation=landscape'
    },
    {
      name: 'Estonya',
      slug: 'estonya',
      flag: '🇪🇪',
      type: 'Schengen',
      description: 'Estonya Schengen vizesi için profesyonel danışmanlık',
      image: 'https://readdy.ai/api/search-image?query=tallinn%20estonia%20old%20town%20medieval%20architecture%20colorful%20buildings%20baltic%20city%20historic%20walls%20towers%20tourist%20destination&width=600&height=400&seq=estonia-tourist-023&orientation=landscape'
    },
    {
      name: 'Amerika',
      slug: 'amerika',
      flag: '🇺🇸',
      type: 'Ulusal Vize',
      description: 'Amerika vizesi başvurularında güvenilir destek',
      image: 'https://readdy.ai/api/search-image?query=statue%20of%20liberty%20new%20york%20usa%20iconic%20landmark%20blue%20sky%20american%20symbol%20freedom%20manhattan%20skyline%20tourist%20destination&width=600&height=400&seq=usa-tourist-024&orientation=landscape'
    }
  ];

  const filteredCountries = countries.filter((country) =>
    country.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/10 via-lightBlue to-white py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="font-heading font-bold text-2xl sm:text-3xl lg:text-5xl text-darkBlue mb-4 sm:mb-6">
              İzmir Vize Danışmanlık Hangi Ülkelere Hizmet Verir?
            </h1>
            <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600 leading-relaxed mb-6 sm:mb-8">
              İzmir'den 50+ ülkeye vize başvurusu için profesyonel danışmanlık hizmeti. Schengen vizesi, Amerika vizesi, İngiltere vizesi ve daha fazlası.
            </p>

            {/* Search Bar */}
            <div className="max-w-xl mx-auto">
              <div className="relative">
                <input
                  type="text"
                  placeholder="Ülke ara..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full px-4 sm:px-6 py-3 sm:py-4 pl-12 sm:pl-14 rounded-full border-2 border-gray-200 focus:border-secondary focus:outline-none font-body text-sm sm:text-base"
                />
                <i className="ri-search-line absolute left-4 sm:left-5 top-1/2 -translate-y-1/2 text-gray-400 text-lg sm:text-xl"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Countries Grid */}
      <section className="py-12 sm:py-16 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
            {filteredCountries.map((country, index) => (
              <Link
                key={index}
                to={`/ulkeler/${country.slug}`}
                className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl hover:border-secondary border-2 border-transparent transition-all duration-300 hover:scale-[1.02] group"
              >
                {/* Country Image */}
                <div className="h-36 sm:h-44 lg:h-48 overflow-hidden relative">
                  <img 
                    src={country.image} 
                    alt={`${country.name} turistik görsel`}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm px-2 py-1 rounded-full">
                    <span className="font-body text-xs font-semibold text-darkBlue">{country.type}</span>
                  </div>
                </div>
                <div className="p-4 sm:p-5">
                  <div className="flex items-center space-x-3 mb-2">
                    <span className="text-2xl sm:text-3xl">{country.flag}</span>
                    <h3 className="font-heading font-bold text-base sm:text-lg text-darkBlue">
                      {country.name} Vizesi
                    </h3>
                  </div>
                  <p className="font-body text-xs sm:text-sm text-gray-600 leading-relaxed mb-3">
                    {country.description}
                  </p>
                  <div className="flex items-center text-secondary font-semibold">
                    <span className="font-body text-xs sm:text-sm">Detaylı Bilgi</span>
                    <i className="ri-arrow-right-line ml-1 group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredCountries.length === 0 && (
            <div className="text-center py-12">
              <i className="ri-search-line text-5xl sm:text-6xl text-gray-300 mb-4"></i>
              <p className="font-body text-sm sm:text-base lg:text-lg text-gray-600">
                Aradığınız ülke bulunamadı. Lütfen farklı bir arama yapın.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Info Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-lightBlue">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-map-pin-line text-secondary text-xl sm:text-2xl lg:text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg lg:text-xl text-darkBlue mb-2 sm:mb-3">
                50+ Ülke
              </h3>
              <p className="font-body text-xs sm:text-sm text-gray-600">
                Dünya genelinde 50'den fazla ülkeye vize başvuru süreçlerinde profesyonel destek sağlıyoruz.
              </p>
            </div>

            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-shield-check-line text-secondary text-xl sm:text-2xl lg:text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg lg:text-xl text-darkBlue mb-2 sm:mb-3">
                Güvenilir Hizmet
              </h3>
              <p className="font-body text-xs sm:text-sm text-gray-600">
                10+ yıllık deneyimimiz ve %98 başarı oranımızla İzmir'in en güvenilir vize danışmanlık merkeziyiz.
              </p>
            </div>

            <div className="bg-white rounded-xl p-5 sm:p-6 lg:p-8 shadow-md">
              <div className="w-12 h-12 sm:w-14 sm:h-14 lg:w-16 lg:h-16 bg-secondary/10 rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-customer-service-2-line text-secondary text-xl sm:text-2xl lg:text-3xl"></i>
              </div>
              <h3 className="font-heading font-bold text-base sm:text-lg lg:text-xl text-darkBlue mb-2 sm:mb-3">
                Tam Destek
              </h3>
              <p className="font-body text-xs sm:text-sm text-gray-600">
                Başvurunuzun her aşamasında yanınızdayız. Evrak hazırlığından vize teslimine kadar.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-12 sm:py-16 lg:py-20 bg-gradient-to-r from-secondary to-orange-500">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-heading font-bold text-xl sm:text-2xl lg:text-4xl text-white mb-3 sm:mb-4">
            Hangi Ülkeye Vize Başvurusu Yapmak İstiyorsunuz?
          </h2>
          <p className="font-body text-sm sm:text-base lg:text-lg text-white/90 mb-6 sm:mb-8">
            Ücretsiz ön değerlendirme için bizimle iletişime geçin
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
            <Link
              to="/iletisim"
              className="bg-white hover:bg-gray-100 text-secondary px-5 sm:px-6 lg:px-8 py-2.5 sm:py-3 lg:py-4 rounded-full font-body font-bold text-sm sm:text-base transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              İletişime Geç
            </Link>
            <a
              href="tel:+905422671171"
              className="bg-white/20 backdrop-blur-sm hover:bg-white/30 text-white border-2 border-white px-5 sm:px-6 lg:px-8 py-2.5 sm:py-3 lg:py-4 rounded-full font-body font-bold text-sm sm:text-base transition-all whitespace-nowrap cursor-pointer"
            >
              +90 542 267 11 71
            </a>
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppButton />
    </div>
  );
}
